import React from 'react';
import { XIcon, AlertCircleIcon } from 'lucide-react';
const mistakes = ['Dietas restrictivas de 1200 calorías que te matan de hambre.', 'Eliminar grupos enteros de alimentos (como los carbohidratos).', 'Pastillas mágicas o batidos que solo te hacen perder líquido.', 'Ejercicio extremo sin darle descanso a tu cuerpo.'];
export function ProblemAgitation() {
  return <section className="py-20 bg-white" data-id="element-172">
      <div className="container mx-auto px-4 max-w-4xl fade-in-section" data-id="element-173">
        <div className="text-center mb-10" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-6" data-id="element-175">
            No es tu culpa.{' '}
            <span className="text-coral" data-id="element-176">El problema no sos vos.</span>
          </h2>
          <p className="text-lg text-text-medium leading-relaxed mb-8" data-id="element-177">
            Tu cuerpo cambió… y nadie te explicó cómo adaptarte.
          </p>
          <div className="bg-white p-6 rounded-2xl shadow-soft border border-beige-dark mb-8 text-center" data-id="element-178">
            <h3 className="text-xl font-bold text-text-dark mb-3" data-id="element-179">
              ¿Quién creó este programa?
            </h3>
            <p className="text-lg text-text-medium leading-relaxed" data-id="element-180">
              Soy Licenciada en Nutrición y trabajo todos los días con mujeres
              que sienten que su cuerpo ya no responde.
              <br data-id="element-181" />
              <br data-id="element-182" />
              <strong className="text-text-dark" data-id="element-183">
                Este sistema nace de esa experiencia real.
              </strong>
            </p>
          </div>
        </div>

        <div className="bg-bg-warm p-6 md:p-8 rounded-3xl shadow-inner mb-10 text-center" data-id="element-184">
          <p className="text-xl md:text-2xl font-bold text-text-dark mb-4" data-id="element-185">
            Después de los 40, tu cuerpo entra en modo defensa.
          </p>
          <p className="text-lg text-text-dark font-semibold mb-6" data-id="element-186">
            La inflamación crónica bloquea tu metabolismo.
          </p>
          <p className="text-lg text-text-medium mb-4" data-id="element-187">Eso significa que:</p>
          <div className="text-lg text-text-dark space-y-2 mb-6" data-id="element-188">
            <p data-id="element-189">❌ Tu cuerpo acumula grasa más fácil</p>
            <p data-id="element-190">❌ Quema menos energía</p>
            <p data-id="element-191">❌ Retiene líquidos</p>
            <p data-id="element-192">❌ Aumenta la ansiedad</p>
          </div>
          <p className="text-lg text-text-dark font-bold" data-id="element-193">
            👉 No es falta de disciplina.
            <br data-id="element-194" />
            👉 Es un problema biológico.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center bg-rose/5 border-l-4 border-coral p-6 rounded-r-2xl mb-12" data-id="element-195">
          <AlertCircleIcon className="text-coral w-12 h-12 mb-4 md:mb-0 md:mr-6 flex-shrink-0" data-id="element-196" />
          <div data-id="element-197">
            <p className="text-xl font-bold text-text-dark mb-2" data-id="element-198">
              Tu metabolismo está bloqueado.
            </p>
            <p className="text-text-medium" data-id="element-199">
              Necesitás reiniciarlo, no seguir forzándolo.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-200">
          <h3 className="text-2xl font-bold text-sage-light-dark text-sage mb-2" data-id="element-201">
            Pero hay una forma diferente...
          </h3>
          <div className="w-12 h-1 bg-sage mx-auto rounded-full" data-id="element-202"></div>
        </div>
      </div>
    </section>;
}